/**************************************************
 * Nombre:       Tarjeta_Banner
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {irUrl} from "../../Utilidades/irUrl";
import banner from '../../Recursos/Temporales/banner.png'
import {FiberManualRecord} from '@mui/icons-material'


const Tarjeta_Banner = ({item}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: `radial-gradient(49.89% 49.89% at 50% 50.11%, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.40) 100%), url(${item.img ? item.img : banner})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                height: 620,
            }}

        >


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff'}}
            >

                <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                            <Typography
                                sx={{
                                    fontSize: !masSM ? 14 : 18,
                                    fontWeight: 600,
                                    color: '#fff',
                                    textAlign: sCell ? 'center' : 'left'
                                }}>{item?.subTituloUno.toUpperCase()}</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 0}}>
                            <Typography sx={{
                                fontSize: !masSM ? 48 : 52,
                                fontWeight: 800,
                                color: '#fff',
                                lineHeight: 1.1,
                                textAlign: sCell ? 'center' : 'left'
                            }}>
                                <span
                                    style={{fontWeight: 500}}>{`${item?.nombre.toUpperCase()}`}</span> {`${item.subTituloDos.toUpperCase()}`}
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 2}}>
                            <Typography sx={{
                                fontSize: 20,
                                fontWeight: 400,
                                color: '#fff',
                                textAlign: sCell ? 'center' : 'left'
                            }}>
                                {item?.descripcion}
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 4, mb: 10}}>
                            {item.textoBoton &&
                                <Button
                                    onClick={() => irUrl(item.link)}
                                    color={'secondary'} sx={{py: 0.8}}
                                    startIcon={<FiberManualRecord color={'primary'}/>}
                                >
                                    {item.textoBoton}
                                </Button>
                            }
                        </Grid>


                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Tarjeta_Banner    